// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1b991356","578":"7cbdbbd7","721":"af8dbf3b","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};